import CalendarIconPath from "@ingka/ssr-icon/paths/calendar";

export default CalendarIconPath;
